import React from "react";
import { useNavigate } from "react-router-dom"
import logo from "images/logo2.svg";

function Header(props) {
  const { wizard, cta } = props;
  const navigate = useNavigate();

  return (
    <nav
      className="
          flex
          flex-wrap 
          lg:flex-no-wrap
          w-full 
          p-4
          bg-white 
          border-bottom
          border-red-400
        "
    >
      <div
        onClick={() => navigate("/")}
        className="
          flex-0
          flex
          items-center
          justify-start
          lg:justify-center
          w-1/2
          lg:w-1/5
          cursor-pointer
        "
      >
        <img src={logo} alt="logo" className="w-10 mr-4" />
        <span
          className="
            font-extrabold
            text-2xl
            font-display
          "
        >
          timesafe.io
          </span>

      </div>
      <div
        className="
          flex-1 

          hidden
          lg:flex

          mx-4
          sm:mx-2
          lg:mx-8
          xl:mx-16

          w-auto
        ">
        {wizard ? wizard : null}
      </div>
      <div className="
          flex
          items-center
          justify-end
          lg:justify-center
          w-1/2
          lg:w-1/5
        "
      >{cta}</div>
      <div
        className="
          flex-1 
          
          flex
          lg:hidden

          pt-6
          
          w-full
        ">
        {wizard ? wizard : null}
      </div>
    </nav>
  );
}

export default Header;
